import React from "react";
import { Enquiries } from "@/pages/AdminDashboard";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function EnquiriesPage() {
  return (
    <LegacyHost
      title="Legacy Enquiries"
      migratedFrom="Editorial desk · Pilot enquiries"
      testid="os-operate-enquiries"
    >
      <Enquiries />
    </LegacyHost>
  );
}
